import { render, staticRenderFns } from "./AssignedClientList.vue?vue&type=template&id=10f6f5e0"
import script from "./AssignedClientList.vue?vue&type=script&lang=js"
export * from "./AssignedClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports